import { render } from "./ZhaiComment.vue?vue&type=template&id=b8021178&scoped=true"
import script from "./ZhaiComment.vue?vue&type=script&lang=js"
export * from "./ZhaiComment.vue?vue&type=script&lang=js"

import "./ZhaiComment.vue?vue&type=style&index=0&id=b8021178&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b8021178"]])

export default __exports__